import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommitteeMeetingDto } from '../../shared/dto/committee-meeting.dto';
import { ControlContainer, NgForm } from '@angular/forms';
import { AuthService, EnvironmentService, NotificationService } from 'src/app/shared';
import { CommitteeMeetingService } from '../../shared/committee-meeting.service';
import { CommitteeMeetingFileTypeEnum } from '../../shared/enum/committee-meeting-file-type.enum';
import { FileService } from 'src/app/shared/file/file.service';
import { environment } from 'src/environments/environment';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-committee-meeting-minutes-edit',
  templateUrl: './committee-meeting-minutes-edit.component.html',
  styleUrls: ['./committee-meeting-minutes-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class CommitteeMeetingMinutesEditComponent implements OnInit, OnChanges {
  @Input() committeeMeeting: CommitteeMeetingDto;
  fileDownloadLink: string;
  fileDownloadLinkForCopy: string;
  awaitingResponse = false;
  fileName: string;

  constructor(
    private _committeeMeetingService: CommitteeMeetingService,
    private _notificationService: NotificationService,
    private _fileService: FileService,
    private _authService: AuthService,
    private _environmentService: EnvironmentService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.committeeMeeting && this.committeeMeeting) {
      const split = this.committeeMeeting.MeetingMinutesS3Key.split('/');
      this.fileName = split.length > 0 ? split[split.length - 1] : '';
      this.fileDownloadLink = `CommitteeMeeting/${this.committeeMeeting.MeetingID}/Minutes`;
      this.setUrlWhenClickingOnCopyLink();
    }
  }

  downloadFile(fileDownloadLink, fileName) {
    this._fileService.downloadFile(fileDownloadLink, fileName);
  }

  fileSelected(event: any) {
    const file = event.target.files[0];
    this._committeeMeetingService
      .uploadFile(this.committeeMeeting.MeetingID, file, CommitteeMeetingFileTypeEnum.Minutes)
      .then((fileKey) => {
        this.committeeMeeting.MeetingMinutesS3Key = fileKey;
        this._notificationService.translateSuccess('committees.edit.committee-meetings.minutes.upload-success');
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  deleteFile() {
    this.awaitingResponse = true;
    this._committeeMeetingService
      .deleteFile(this.committeeMeeting.MeetingID, CommitteeMeetingFileTypeEnum.Minutes)
      .then(() => {
        this.committeeMeeting.MeetingMinutesS3Key = '';
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.awaitingResponse = false;
      });
  }

  setUrlWhenClickingOnCopyLink() {
    let webAppUrl = this._environmentService.getEnvironmentConfig().WebApiUrl;
    let tenant = this._authService.getTenant();
    this.fileDownloadLinkForCopy = `${webAppUrl}/api/${this.fileDownloadLink}/?x-tenant=${tenant}`;
  }
}
